module.exports = __webpack_public_path__ + "img/Croatia.31d0b683.png";